import { render, staticRenderFns } from "./AccountantsSettingsMenu.vue?vue&type=template&id=5ec919e4&scoped=true&"
import script from "./AccountantsSettingsMenu.vue?vue&type=script&lang=js&"
export * from "./AccountantsSettingsMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ec919e4",
  null
  
)

export default component.exports